import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TutorialService } from 'src/app/services/tutorial.service';

@Component({
    selector: 'role-help-dialog',
    templateUrl: './role-help-dialog.component.html',
    styleUrls: ['./role-help-dialog.component.scss'],
})
export class RoleHelpDialogComponent implements OnInit {

    constructor(
        public dialogRef: MatDialogRef<RoleHelpDialogComponent>,
        public tutorialService: TutorialService,
    ) { }

    ngOnInit() { }

    get shouldShowInlineTutorial(): boolean {
        return this.tutorialService.isStepActive('lab-members-role-help') || this.tutorialService.isStepActive('gadget-users-role-help');
    }

    close() {
        this.dialogRef.close();
    }

    exitTutorial() {
        this.tutorialService.cancelActiveTutorial();
    }
}
